<template>
    <div class="notice-bar" ref="noticeBar">
      <div class="notice-content">
        <span>{{ message }}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ScrollNoticeBar',
    props: {
      message: {
        type: String,
        required: true
      },
      speed: {
        type: Number,
        default: 50 // 滚动速度，单位为像素/秒
      }
    },
    mounted() {
      this.startScroll();
    },
    methods: {
      startScroll() {
        const contentWidth = this.$refs.noticeBar.clientWidth; // 获取内容宽度
        const content = this.$refs.noticeBar.querySelector('.notice-content');
        let position = contentWidth; // 初始位置设为内容宽度，以便从屏幕外开始滚动
        const speed = this.speed; // 滚动速度
        const interval = 1000 / speed; // 计算每次移动的间隔时间
        let timer = setInterval(() => {
          if (position < -content.offsetWidth) { // 当内容完全移出屏幕后，重置位置并重新开始滚动
            position = contentWidth; // 重置位置到屏幕外
            content.style.transform = `translateX(${position}px)`; // 重新设置位置
          } else {
            position -= 1; // 每次移动1px（根据speed调整）
            content.style.transform = `translateX(${position}px)`; // 更新位置
          }
        }, interval);
        this.$emit('scroll-started', timer); // 发出事件，表示滚动开始，可以用于外部控制或清理定时器
      }
    },
    beforeDestroy() {
      // 组件销毁前清除定时器，防止内存泄漏
      clearInterval(this.timer); // 确保timer在组件实例中存在，或者在startScroll方法中返回timer并在这里使用它。这里为了示例简化，我们假设在startScroll中直接处理了清理逻辑。
    }
  }
  </script>
  
  <style scoped>
  .notice-bar {
    overflow: hidden; /* 隐藏溢出的内容 */
    white-space: nowrap; /* 防止文本换行 */
    background-color: #f0f0f0; /* 背景颜色 */
    padding: 10px; /* 内边距 */
  }
  .notice-content {
    display: inline-block; /* 使内容可以水平滚动 */
    transition: transform 0.5s linear; /* 平滑过渡效果 */
  }
  </style>
  